exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 576px){.nav-item{padding-left:20px}}\n", ""]);

// exports
